// GutMicrobiomeCard.jsx

import React from "react";
import BasePackageCard from "./BasePackageCard";
import { GUT5 } from "../../../../constants";
import { useTranslation } from "../../../../language";

export default function GutMicrobiomeCard() {
  const { t } = useTranslation();

  const panel = {
    id: "microbiome",
    title: t("card_gut_title"),
    subtitle: t("card_gut_desc"),
    biomarkers: t("card_gut_markers"),
    price: "€ 199",
    image: GUT5,
    rawMarkers: true,
  };

  return <BasePackageCard panel={panel} />;
}